import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import config from "../../config";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../Components/Dashboard/css/lighttheme.css";
import Connectwallet from "../Pages/Presale/Connectwallet";
import {
  Button,
  Container,
  Form,
  Nav,
  Navbar,
  Offcanvas,
  Dropdown,
  Modal,
  Row,
  Col,
  NavDropdown,
  Accordion
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import * as ACTIONTYPES from "../../redux/actionTypes";
import { useDisconnect } from "wagmi";
import DashboardMenus from "../Appsidebar/DashboardMenus";

const Presaleheader = (props) => {
  const { setOpenBuyForm, connectWalletNow } = props;
  const _useDisconnect = useDisconnect();
  const _useLocation = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loginDetails = useSelector((state) => state.auth.LoginDetails);
  const walletConnnected = useSelector((state) => state.auth.walletConnnected);
  const DarkTheme = useSelector((state) => state.auth.isDarkTheme);

  const [LoginData, setLoginData] = useState([]);
  const [WalletAddress, setWalletAddress] = useState("");
  const [show, setShow] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const url = new URL(window.location.href);
  const lastPart = url.pathname.split("/").pop();

  const FindHeader = () => {
    if (_useLocation.pathname.search(config.Exchange) > -1) {
      return config.Exchange;
    } else if (_useLocation.pathname.search(config.LaunchApp) > -1) {
      return config.LaunchApp;
    } else {
      return "";
    }
  };
  const [loadHeader, setLoadHeader] = useState(FindHeader());

  const handleClose = () => {
    setShow(false);
    if (props?.setconnectWalletNow) {
      props?.setconnectWalletNow(false);
    }
  };

  useEffect(() => {
    console.log(Object.keys(loginDetails).length > 0, "_useLocation.pathname");
    // Update body class when isClicked changes
    document.body.classList.toggle("light-skin", DarkTheme);
    if (config.LaunchApp != loadHeader) {
      document.body.classList.remove("light-skin");
    }
  }, [DarkTheme]);

  useEffect(() => {
    setLoginData(loginDetails);
  }, [loginDetails]);

  useEffect(() => {
    if (props?.isLogout) {
      LogOut();
    }
  }, [props?.isLogout]);

  useEffect(() => {
    setShow(connectWalletNow);
  }, [connectWalletNow]);

  useEffect(() => {
    setWalletAddress(walletConnnected);
    console.log(lastPart, "lastpart");
    if (props?.setconnectWalletNow) {
      props?.setconnectWalletNow(false);
    }
    setShow(false);
  }, [walletConnnected]);

  const LogOut = () => {
    dispatch({ type: ACTIONTYPES.walletConnnected, payload: "" });
    dispatch({ type: ACTIONTYPES.USERLOGIN, payload: [], token: [] });
    navigate(`${config.Exchange}`);
  };

  const buyToken = () => {
    if (WalletAddress) {
      setOpenBuyForm(true);
    } else {
      setShow(true);
    }
  };
  const disconnectWallet = () => {
    _useDisconnect.disconnect();
    dispatch({ type: ACTIONTYPES.walletConnnected, payload: "" });
  };

  const handleClick = () => {
    dispatch({ type: ACTIONTYPES.DarkTheme, payload: !DarkTheme });
    // setIsClicked(!isClicked);
  };

  return (
    <>
      {/* Presale Header Start  */}

      <div className="header">

        {["xl"].map((expand) => (
          <Navbar key={expand} expand={expand} className="">
            <Container>
              <Navbar.Brand
                href={
                  loadHeader == config.baseurl
                    ? config.baseurl
                    : config.Exchange
                }
                className="text-white"
              >
                <img src="assets/images/logo/logo.svg" width="170px" />
              </Navbar.Brand>
              {/* {!loadHeader && ( */}
              <Navbar.Toggle
                aria-controls={`offcanvasNavbar-expand-${expand}`}
              />
              {/* )} */}

              {/* <Mobileappsidebar /> */}

              <Navbar.Offcanvas
                id={`offcanvasNavbar-expand-${expand}`}
                aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                placement="end"
                className=""
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                    <img src="assets/images/logo/logo.svg" width={`170px`} />
                  </Offcanvas.Title>
                </Offcanvas.Header>

                <Offcanvas.Body>
                  {loadHeader != config.LaunchApp &&
                    <Nav className="align-items-xl-center justify-content-center flex-grow-1">

                      {/* <Nav.Link
                      className=""
                      href="../How it works.pdf" 
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      How It Works
                    </Nav.Link>
                    &emsp;
                    <Nav.Link
                      className={`${lastPart == "aboutus" || lastPart == "" ? "" : ""
                        }`}
                      href={`${config.Exchange}aboutus`}
                    >
                      About Us
                    </Nav.Link>
                    &emsp;
                    <Nav.Link href={`${config.Exchange}faq`}>FAQs</Nav.Link> 
                    &emsp;
                    <Nav.Link href={'https://infimultichain.com/ico/blog'} target="_blank">Blog</Nav.Link>
                    &emsp;
                    <Nav.Link
                      className=""
                      href="../Staking & Rewards Explained.pdf" 
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Staking & Rewards
                    </Nav.Link>
                    &emsp; */}

                    </Nav>}


                  {loadHeader == config.LaunchApp && (
                    <Nav className="justify-content-center flex-grow-1 me-3">
                    </Nav>
                  )}
                  <Form className="headbtndiv">
                    {/* {(_useLocation.pathname == "/exch/aboutus" || _useLocation.pathname == "/exch/faq" || _useLocation.pathname == '/app/dashboard' || _useLocation.pathname == '/app/simplestaking') &&
                      <Button
                        href={`${config.Exchange}`}
                        variant="custombtn"
                        className="text-decoration-none d-inline-block  bg-white"
                      >
                        HOME
                      </Button>
                      } */}
                 
                      <NavDropdown
                        title="Quick Links"
                        id="basic-nav-dropdown"
                        className="headerDropdown"
                      >
                        {/* <div className="d-head mb-2">INFI Hub</div> */}
                        <div className="p-3">
                          <Accordion defaultActiveKey="0" alwaysOpen>
                            <NavDropdown.Item
                              href='https://launchpad.infimultichain.com/'
                              target="_blank"
                              rel="noreferrer noopener"
                              className="mb-2 active"
                            >
                              <div className="d-flex align-items-center">
                                <div>
                                  <img
                                    src="assets/images/dashboard/icon/home.svg"
                                    className=""
                                    alt=""
                                  />
                                </div>
                                <div>INFI HUB</div>
                              </div>
                            </NavDropdown.Item>

                            <Accordion.Item eventKey="1" className="mb-2">
                              <Accordion.Header>
                                {" "}
                                <img
                                  src="assets/images/dashboard/icon/swap.svg"
                                  className=""
                                  alt=""
                                />
                                INFI Main
                              </Accordion.Header>
                              <Accordion.Body className="p-0">
                                <NavDropdown.Item href="https://infimultichain.com/app/simplestaking" target="_blank" rel="noreferrer noopener">
                                  Staking
                                </NavDropdown.Item>
                                <NavDropdown.Item href="https://infimultichain.com/app/dashboard" target="_blank" rel="noreferrer noopener">
                                  SbSe Pools
                                </NavDropdown.Item>
                                <NavDropdown.Item href="#action/3.3">
                                  Profits
                                </NavDropdown.Item>
                              </Accordion.Body>
                            </Accordion.Item>
                            <NavDropdown.Item
                              href={"https://infimultichain.com/ico/"}
                              target="_blank"
                              rel="noreferrer noopener"
                              className="mb-2"
                            >
                              <img
                                src="assets/images/dashboard/icon/ico.svg"
                                className=""
                                width={`22px`}
                                alt=""
                              />{" "}
                              INFI ICO
                            </NavDropdown.Item>
                            <Accordion.Item eventKey="2" className="mb-2">
                              <Accordion.Header>
                                {" "}
                                <img
                                  src="assets/images/dashboard/icon/launchpad.svg"
                                  className=""
                                  alt=""
                                />
                                INFI Launchpad
                              </Accordion.Header>
                              <Accordion.Body className="p-0">
                                <NavDropdown.Item href={`https://launchpad.infimultichain.com/launchpad`} target="_blank" rel="noreferrer noopener">
                                  Launchpad Home
                                </NavDropdown.Item>
                                <NavDropdown.Item href={`https://launchpad.infimultichain.com/launchpad#activepresale`} target="_blank" rel="noreferrer noopener">
                                  Active ICO's
                                </NavDropdown.Item>
                                <NavDropdown.Item href={`https://launchpad.infimultichain.com/launchpad#listed`} target="_blank" rel="noreferrer noopener">
                                  Listed
                                </NavDropdown.Item>
                              </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3" className="">
                              <Accordion.Header>
                                {" "}
                                <img
                                  src="assets/images/dashboard/icon/swap.svg"
                                  className=""
                                  alt=""
                                />
                                Swap
                              </Accordion.Header>
                              <Accordion.Body className="p-0">
                                <NavDropdown.Item >
                                  SbSe Order Book (soon)
                                </NavDropdown.Item>
                                <NavDropdown.Item >
                                  SbSe Instant (soon)
                                </NavDropdown.Item>
                                <NavDropdown.Item>
                                  MarketPlace (soon)
                                </NavDropdown.Item>
                                <NavDropdown.Item >
                                  INFI Hybrid eWallet (soon)
                                </NavDropdown.Item>
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        </div>
                      </NavDropdown>
              
                    &nbsp;&nbsp;
                    {Object.keys(loginDetails).length == 0 && (
                      <>
                        <Button
                          href={`${config.baseurl}login`}
                          variant="custombtn"
                          className=""
                        >
                          LOGIN
                        </Button>
                        &nbsp;&nbsp;
                      </>
                    )}
                    <Dropdown className=" userBtn">
                      {Object.keys(loginDetails).length > 0 && (
                        <Dropdown.Toggle
                          id="dropdown-basic"
                          className="text-primary bg-transparent border-0"
                        >
                          {
                            loginDetails.profilePic == null || loginDetails.profilePic == undefined || loginDetails.profilePic == "" || !loginDetails.profilePic ? <img
                              src="assets/icons/profileIcon.png"
                              width="45px"
                            /> : <img
                              alt=""
                              width="45px"
                              src={`${config.s3BaseUrl +
                                loginDetails?.profilePic
                                }`}
                            />
                          }

                        </Dropdown.Toggle>
                      )}
                      <Dropdown.Menu>
                        {Object.keys(loginDetails).length > 0 && (
                          <>
                            {!WalletAddress && (
                              <Dropdown.Item
                                className=" me-3 d-inline-block"
                                onClick={() => setShow(true)}
                              >
                                Connect wallet
                              </Dropdown.Item>
                            )}
                            {WalletAddress && (
                              <Dropdown.Item
                                onClick={() => disconnectWallet()}
                                variant="outline-primary"
                                className=" me-3 d-inline-block "
                              >
                                {WalletAddress.toString().substring(0, 6) +
                                  "..." +
                                  WalletAddress.toString().substr(
                                    WalletAddress.length - 6
                                  )}
                              </Dropdown.Item>
                            )}
                          </>
                        )}
                        <Dropdown.Item
                          className=" me-3 d-inline-block"
                        >
                          <Link to={`${config.LaunchApp}dashboard`}>
                            App Launch
                          </Link>
                        </Dropdown.Item>
                        <Dropdown.Item
                          className=" me-3 d-inline-block"
                        >
                          <Link to={`${config.LaunchApp}profile`}>
                            Profile
                          </Link>
                        </Dropdown.Item>
                        <Dropdown.Item
                          className=" me-3 d-inline-block"
                        >
                          <Link to={`${config.LaunchApp}profilechangepassword`}>
                            Change Password
                          </Link>
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                    <Connectwallet
                      show={show}
                      onHide={handleClose}
                      loginDetails={loginDetails}
                    />
                  </Form>
                  {loadHeader == config.LaunchApp && (
                    <div class="menudiv sideinr mobilesidebar">
                      <DashboardMenus />
                    </div>
                  )}
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </Container>
          </Navbar>
        ))}
      </div>

      {/* Presale Header Exit  */}
    </>
  );
};

export default Presaleheader;
